import { useState } from 'react';

const MAX_REMARKS_LENGTH = 100;

interface Props {
  title: string;
  message: string;
  loading?: boolean;
  onConfirm: (remarks: string) => void;
  onCancel: () => void;
  placeholder?: string;
  confirmText?: string;
  loadingText?: string;
}

const ConfirmationModal = ({
  title,
  message,
  loading,
  onConfirm,
  onCancel,
  placeholder = 'Enter reason for rejection',
  confirmText = 'Yes',
  loadingText = 'Rejecting...',
}: Props) => {
  const [remarks, setRemarks] = useState('');
  const [error, setError] = useState('');

  const handleConfirm = () => {
    if (!remarks.trim()) {
      setError('Remarks is required');
      return;
    }

    if (remarks.length > MAX_REMARKS_LENGTH) {
      setError(`Remarks cannot exceed ${MAX_REMARKS_LENGTH} characters`);
      return;
    }

    onConfirm(remarks);
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
        <h3 className="text-lg font-semibold mb-4">{title}</h3>

        <p className="mb-4">{message}</p>

        <div className="mb-4">
          <label className="block text-sm font-medium mb-2">
            Remarks <span className="text-red-500">*</span>
          </label>

          <textarea
            value={remarks}
            onChange={(e) => {
              setRemarks(e.target.value);
              setError('');
            }}
            maxLength={MAX_REMARKS_LENGTH}
            rows={4}
            className="w-full border border-gray-300 rounded-md px-3 py-2"
            placeholder={placeholder}
          />

          <p className="text-right text-sm text-gray-500 mt-1">
            {remarks.length}/{MAX_REMARKS_LENGTH}
          </p>

          {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
        </div>

        <div className="flex justify-end gap-3">
          <button onClick={onCancel} disabled={loading} className="px-4 py-2 border rounded-md disabled:opacity-60">
            No
          </button>

          <button onClick={handleConfirm} disabled={loading} className="px-4 py-2 bg-red-600 text-white rounded-md">
            {loading ? loadingText : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
